export default __webpack_public_path__ + "static/media/airport_pale.6c190999.svg";